import AsyncAutocomplete from '.././../../../src/component/comman/AsyncAutoComplete';
import { apiRequest } from '../../../utils/config/apiRequest';
import { _sessionKeys, _sessionType, _status, DISCOUNT_TYPE, USERTYPE_ENUM } from '../../../utils/Constant';
import { apiUrl } from '../../../utils/endPoints/apiUrl';
import { LoadingButton } from '@mui/lab';
import { FormControl, FormHelperText, Grid, MenuItem, Select, Stack, TextField, Typography } from '@mui/material'
import { useFormik } from 'formik';
import React, { useState } from 'react'
// import { _addCouponValSchema } from '../../../../src/component/';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers'; 
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { accessSessionData } from '../../../utils/helper/authHelper';
import dayjs from "dayjs";


export default function AddEditCoupon({ data = {}, onAction = () => { } }) {
    const [load, setLoad] = useState(false)
    
      const user = accessSessionData(
      _sessionType.getdata,
      _sessionKeys.loggedInUser
    )

 
    // Assign formik initial values

    let initialValues = {
        purpose: data?.purpose || '',
        couponCode: data?.couponCode || '',
        discountType: data?.discountType || null,
        discount: data?.discount || '',
        validFrom: data?.validFrom || '',
        validTo: data?.validTo || '',
        applicableShopKeeper: user?._id || '',
        applicableShops: data?.applicableShopIds || [],
        applicableUsers: data?.applicableUserIds || [],
        maxUsageLimit: data?.maxUsageLimit
    }
    
    // formik
    const { values, touched, errors, setFieldValue, handleChange, handleSubmit } = useFormik({
        initialValues,
        // validationSchema: _addCouponValSchema,
        onSubmit: handleCouponAdd
    })

    // Handle api's
    async function handleCouponAdd() {
        let payload = {
            ...(data?._id && { couponId: data?._id }),
            purpose: values?.purpose || '',
            couponCode: values?.couponCode || '',
            discountType: values?.discountType || null,
            discount: values?.discount || '',
            validFrom: values?.validFrom || '',
            validTo: values?.validTo || '',
            maxUsageLimit: values?.maxUsageLimit || 0,
            applicableShopKeeperId: user?._id,
            applicableShopIds: values?.applicableShops?.length > 0 ?  values?.applicableShops?.map(item => item._id) : [],
            applicableUserIds: values?.applicableUsers?.map(item => item._id) || [],
            sourceOfCreation : "VENDOR",
            createdBy : user?._id
        }
        
        setLoad(true)
        let { status } = await apiRequest({
            method: "POST",
            endUrl: apiUrl.coupons.coupon,
            body: payload,
            showMsg: true
        });
        setLoad(false);
        status && onAction()
    }

    const getApplicableUsers = async (searchQ, userType) => {
        let { data, status } = await apiRequest({
            endUrl: apiUrl.users.listing,
            query: {
                searchQ,
                userType,
                status: _status.active
            },
        });
        if (status) return data?.rows || []
        else return []
    }


    const getApplicableShops = async (searchQ) => {
        let { data, status } = await apiRequest({
            endUrl: apiUrl.branch.listing,
            query: {
                searchQ,
                status: _status.active
            },
        });
        if (status) return data?.rows || []
        else return []
    }

    return (
       <LocalizationProvider dateAdapter={AdapterMoment}>
            <Grid container spacing={2}>
                <Grid item md={4} xs={12}>
                    <Typography variant='subtitle2' required>Purpose</Typography>
                    <TextField
                        name='purpose'
                        fullWidth
                        size="small"
                        placeholder="Purpose/Title"
                        value={values.purpose}
                        onChange={handleChange}
                        error={Boolean(touched.purpose && errors.purpose)}
                        helperText={touched.purpose && errors.purpose}
                    />
                </Grid>
                <Grid item md={4} xs={12}>
                    <Typography variant='subtitle2'>Code</Typography>
                    <TextField
                        name='couponCode'
                        fullWidth
                        size="small"
                        placeholder="Code"
                        value={values.couponCode}
                        onChange={handleChange}
                        error={Boolean(touched.couponCode && errors.couponCode)}
                        helperText={touched.couponCode && errors.couponCode}
                    />
                </Grid>
                <Grid item md={4} xs={12}>
                    <Typography variant='subtitle2'>Max Usage</Typography>
                    <TextField
                        name='maxUsageLimit'
                        fullWidth
                        size="small"
                        placeholder="1"
                        value={values.maxUsageLimit}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item md={6} xs={12}>
                    <Typography variant='subtitle2' required>Discount Type</Typography>
                    <FormControl fullWidth size="small" variant="outlined">
                        <Select
                            name='discountType'
                            value={values.discountType}
                            onChange={handleChange}
                            error={Boolean(touched.discountType && errors.discountType)}
                            helperText={touched.discountType && errors.discountType}
                        >
                            <MenuItem value={DISCOUNT_TYPE.PERCENTAGE}>Perc</MenuItem>
                            <MenuItem value={DISCOUNT_TYPE.FIXED}>Fixed</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item md={6} xs={12}>
                    <Typography variant='subtitle2' required>Discount</Typography>
                    <TextField
                        name='discount'
                        fullWidth
                        size="small"
                        placeholder="Discount"
                        value={values.discount}
                        onChange={handleChange}
                        error={Boolean(touched.discount && errors.discount)}
                        helperText={touched.discount && errors.discount}
                    />
                </Grid>
                <Grid item md={6} xs={12}>
                    <Typography variant='subtitle2' required>Valid From</Typography>
                    <DatePicker
                        sx={{ width: '100%' }}
                        format="YYYY-MM-DD"
                        value={values?.validFrom ? moment(values?.validFrom) : null}
                        disablePast
                        slotProps={{ textField: { size: "small" } }}
                        // onChange={(date) => setFieldValue('validFrom', date)}
                        onChange={(date) => {
                            const formatted = moment(date).format("YYYY-MM-DD"); 
                            setFieldValue('validFrom', formatted);

                            if (values.validTo && moment(formatted).isAfter(values.validTo)) {
                                setFieldValue('validTo', null);
                            }
                        }}
                        error={Boolean(touched.validFrom && errors.validFrom)}
                        helperText={touched.validFrom && errors.validFrom}
                    />
                    {Boolean(touched.validFrom && errors.validFrom) && <FormHelperText error>{errors.validFrom}</FormHelperText>}
                </Grid>
                <Grid item md={6} xs={12}>
                    <Typography variant='subtitle2' required>Valid To</Typography>

                    <FormControl fullWidth error={Boolean(touched.validTo && errors.validTo)}>
                        <DatePicker
                        format="YYYY-MM-DD"
                        value={values?.validTo ? moment(values?.validTo) : null}
                        disablePast
                        minDate={values.validFrom ? moment(values.validFrom).startOf("day") : undefined} 
                        // onChange={(date) => setFieldValue('validTo', date)}
                         onChange={(date) => {
                            const formatted = moment(date).format("YYYY-MM-DD"); 
                            setFieldValue('validTo', formatted);
                        }}
                        slotProps={{
                            textField: {
                            size: "small",
                            error: Boolean(touched.validTo && errors.validTo),
                            helperText: touched.validTo && errors.validTo
                            }
                        }}
                        />
                    </FormControl>
                </Grid>

                {/* <Grid item md={12} xs={12}>
                    <Typography variant='subtitle2'>Shop Keeper (Applicable)</Typography>
                    <AsyncAutocomplete
                        label="Shop keeper"
                        placeholder="Search ShopKeeper"
                        value={values.applicableShopKeeper}
                        onChange={(val) => setFieldValue("applicableShopKeeper", val)}
                        fetchOptions={(text) => getApplicableUsers(text, USERTYPE_ENUM.VENDOR)}
                        getOptionLabel={(option) => option?.userName || ""}
                        isOptionEqualToValue={(o, v) => o?._id === v?._id}
                        renderOption={(props, option) => (
                            <li {...props} key={option?._id}>
                                <Stack>
                                    <Typography variant='subtitle2'> {option.userName} </Typography>
                                    <Typography variant='caption'>{option.email}</Typography>
                                </Stack>
                            </li>
                        )}
                    />
                </Grid> */}

                <Grid item md={12} xs={12}>
                    <Typography variant='subtitle2'>Shops (Applicable)</Typography>
                    <AsyncAutocomplete
                        multiple
                        label="Shops"
                        placeholder="Search Shops"
                        value={values.applicableShops}
                        onChange={(val) => setFieldValue("applicableShops", val)}
                        fetchOptions={(text) => getApplicableShops(text)}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(o, v) => o?._id === v?._id}
                        renderOption={(props, option) => (
                            <li {...props} key={option?._id}>
                                <Stack>
                                    <Typography variant='subtitle2'> {option.name} </Typography>
                                </Stack>
                            </li>
                        )}
                    />
                </Grid>

                <Grid item md={12} xs={12}>
                    <Typography variant='subtitle2'>Customers(Applicable)</Typography>
                    <AsyncAutocomplete
                        multiple
                        label="Customer"
                        placeholder="Search Customer"
                        value={values.applicableUsers}
                        onChange={(val) => setFieldValue("applicableUsers", val)}
                        fetchOptions={(text) => getApplicableUsers(text, USERTYPE_ENUM.CUSTOMER)}
                        getOptionLabel={(option) => option?.userName || ""}
                        isOptionEqualToValue={(o, v) => o?._id === v?._id}
                        renderOption={(props, option) => (
                            <li {...props} key={option?._id}>
                                <Stack>
                                    <Typography variant='subtitle2'> {option.userName} </Typography>
                                    <Typography variant='caption'>{option.email}</Typography>
                                </Stack>
                            </li>
                        )}
                    />
                </Grid>

                <Grid item md={12} xl={12} mt={3} display={"flex"} justifyContent={"center"}>
                    <LoadingButton
                        sx={{ minWidth: 150 }}
                        type='button'
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        Add
                    </LoadingButton>
                </Grid>
            </Grid>
        </LocalizationProvider>
    )
}
